import { updatePolicyScan } from './policy-scan-service';
import { IPolicyScan } from 'types';

export const masRequestCallback = (
  policyScanId: string,
  policyId: string,
  phone: string,
  createdBy?: string,
  successPage: number = 4,
  formValues: Record<string, any> = {},
): Promise<any> => {
  const now = new Date().toISOString();
  return updatePolicyScan({
    id: policyScanId,
    sk: policyId,
    createdBy,
    masSavedQuoteInfo: {
      ...formValues,
      phone,
      page: successPage,
      callbackRequestedAt: now,
    },
    callbackRequestedAt: now,
    callbackProviderName: 'MAS',
  } as unknown as IPolicyScan);
};
